module.exports = __webpack_public_path__ + "10c7a1bd28aebd247caa9f1eff980c7f.pdf";